import { runInInjectionContext, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import Shepherd from 'shepherd.js';
type StepOptions = Shepherd.Step.StepOptions;
import { commonConfig, waitForElement } from './utils';

export function getMyFeedTourMobileSteps(injector: Injector): StepOptions[] {
  return runInInjectionContext(injector, () => {
    const router = inject(Router);

    return [
      {
        id: 'MyFeed-mobile-step-01',
        title: 'Access My Feed',
        text: 'Welcome to your personalized content hub. Here, you’ll find articles, news, and updates tailored to your interests.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#HomeMobileStep1',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              router.navigate(['/site/my-cullen']).then(() => {
                this.next();
              });
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'MyFeed-mobile-step-02',
        title: 'Explore your content by Topics',
        text: 'Navigate through content organized by topics. This helps you quickly find updates relevant to your interests.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#MyFeedStep2',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'MyFeed-mobile-step-03',
        title: 'Add topics to your feed',
        text: 'Click here to customize your feed by adding topics you care about. This ensures your feed stays relevant.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#MyFeedStep3',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              router.navigate(['/site/settings/topics']).then(() => {
                this.next();
              });
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'MyFeed-mobile-step-04',
        title: 'Add a topic',
        text: 'Click the "+" button to add a new topic to your feed.',
        classes: 'shepherd-custom shepherd-custom-upper-position',
        attachTo: {
          element: '#MyFeedStep4',
          on: 'top' as const
        },
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#MyFeedStep4').then(() => {
              setTimeout(() => {
                resolve();
              }, 500);
            });
          });
        },
        buttons: [
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'MyFeed-mobile-step-05',
        title: 'Access Topic Page',
        text: 'Click on a topic name to view all related documents and updates.',
        classes: 'shepherd-custom shepherd-custom-upper-position',
        attachTo: {
          element: '#MyFeedStep5-1',
          on: 'top' as const
        },
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#MyFeedStep5-1').then(() => {
              setTimeout(() => {
                resolve();
              }, 500);
            });
          });
        },
        buttons: [
          {
            text: 'Next',
            action() {
              router.navigate(['/site/topic/49fc7164-0feb-4cdd-aa14-b0a5a099f42f']).then(() => {
                this.next();
              });
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'MyFeed-mobile-step-06',
        title: "Follow topic and browse publications",
        text: 'Follow the topic to receive notifications when new documents are published. You can also browse all existing content within this topic.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#MyFeedStep6',
          on: 'bottom' as const
        },
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#MyFeedStep6').then(() => {
              setTimeout(() => {
                resolve();
              }, 500);
            });
          });
        },
        buttons: [
          {
            text: 'Finish',
            action() {
              this.complete();
              router.navigate(['/site/help']);
            }
          }
        ]
      },
    ];
  });
}